<div class="app-progress-host">
  @if (isLoading$ | async) {
  <seech-progress-bar
    [isIndeterminate]="true"
    [color]="'primary'"
  ></seech-progress-bar>
  }
</div>
<router-outlet></router-outlet>
